<template>
  <div class="padding">
    <h1 class="fonte text-uppercase">GESTÃO FÁCIL</h1>
    <p class="black--text"></p>
    <v-divider class="mt-4"></v-divider>
    <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
            <v-flex xs12 sm6 md3>
                <CardStatus
                    title="Envios do mês"
                    icon="check"
                    color="#00897B"
                    :total="getUserLocal.sumaryV2.enviadasMes || 0"
                >
                </CardStatus>
            </v-flex>
            <v-flex xs12 sm6 md3>
                <CardStatus
                    title="Enviadas - Hoje"
                    icon="phone_forwarded"
                    color="#006989"
                    :total="getUserLocal.sumaryV2.enviadasDia || 0"
                >
                </CardStatus>
            </v-flex>
            <v-flex xs12 sm6 md3>
                <CardStatus
                    title="Alertas"
                    icon="error_outline"
                    color="#89003C"
                    :total="getUserLocal.sumaryV2.errosDia || 0"
                >
                </CardStatus>
            </v-flex>
            <v-flex xs12 sm6 md3>
                <CardStatus
                    title="Recebidas - 24hs atrás"
                    icon="ring_volume"
                    color="#00894D"
                    :total="getUserLocal.sumaryV2.recebidasDia || 0"
                ></CardStatus>
            </v-flex>
        </v-layout>
    </v-container>
    <v-card>
      <v-card-title class="fonte headline">Resumo de envios</v-card-title>
        <v-container >
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-select
              :items="itensResumo"
              item-value="type"
              item-text="label"
              v-model="tipoDeResumo"
              color="teal"
              box
              label="Período"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm4 md4 v-if="tipoDeResumo == 'personalizado'" pl-4 pr-4>
            <span class="caption">Data Inicial</span>
            <datetime
              type="datetime"
              class="subheading"
              v-model="filtro.dataInicial"
              format="dd/MM/yyyy HH:mm"
              :max-datetime="filtro.hoje"
            ></datetime>
          </v-flex>
          <v-flex xs12 sm4 md4 v-if="tipoDeResumo == 'personalizado'"  pl-4 pr-4>
            <span class="caption font-weight-regular">Data Final</span>
            <datetime
              type="datetime"
              class="subheading"
              v-model="filtro.dataFinal"
              format="dd/MM/yyyy HH:mm"
              :min-datetime="filtro.dataInicial"
            ></datetime>
          </v-flex>
          <v-flex>
            <v-btn
              :loading="isLoadingResumo"
              :disabled="isLoadingResumo"
              color="fundo"
              @click="sendLoadResumo()"
              large
              round
            >
              <v-icon left>search</v-icon> Pesquisar
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>cached</v-icon>
                </span>
              </template>
            </v-btn>
          </v-flex>
        </v-layout>
        </v-container>
      <v-card-text>
        <h2 class="fonte pl-3">Envios de SMS</h2>
        <h2 class="fonte mt-3 pl-3">Totais</h2>
        <h3 class="pl-3">Sucessos: <span class="primary--text font-weight-bold">{{filtraTotais(dataResumo).sucessos}}</span> Erros: <span class="red--text font-weight-bold">{{filtraTotais(dataResumo).erros}}</span></h3>
        <div class="pa-4">
          <line-chart
            :messages="{empty: 'Sem dados'}"
            :data="dataResumo"
            xtitle="Dias"
            ytitle="Total de SMS"
            :discrete="true"
          ></line-chart>
        </div>
        <!--
        <h2 class="fonte pl-3">Envios de Notificação Push</h2>
        <div class="pa-4">
            <line-chart :data="dataResumo"></line-chart>
        </div>-->
      </v-card-text>
    </v-card>
  </div>
</template>


<script>
  import CardStatus from '../../CardStatus'
  import { mapActions } from 'vuex'
  import getStatus from '../../../helpers/getStatus'
  import moment from 'moment'

  export default {
    components:{
      CardStatus
    },
    data () {
      return {
        tipoDeResumo: 'atual',
        itensResumo: [
          {
            type: 'atual',
            label: 'Mês atual'
          },
          {
            type: 'anterior',
            label: 'Mês anterior'
          },
          {
            type: 'personalizado',
            label: 'Personalizado'
          }
        ],
        filtro:{
          hoje: moment(new Date()).format('YYYY-MM-DD'),
          dataInicial: moment(new Date()).tz('America/Sao_Paulo').set('date', 1).format('YYYY-MM-DD') + 'T00:00',
          dataFinal:moment(new Date()).tz('America/Sao_Paulo').set('date', moment(this.hoje).format('D')).format('YYYY-MM-DD') + 'T23:59',
        },
        dataResumo: [],
        isLoadingResumo: false
      }
    },
    methods: {
      ...mapActions(['loadUserLocal', 'loadResumo']),
      convertData (data) {
        return moment.utc(data).format('DD/MM/YYYY HH:mm:ss')
      },
      status (status) {
        return getStatus(status)
      },
      async sendLoadResumo () {
        this.isLoadingResumo = true
        let search = {
          type: this.tipoDeResumo,
          filtro: {
            dataInicial: moment(this.filtro.dataInicial).format('YYYY-MM-DD HH:mm:ss'),
            dataFinal: moment(this.filtro.dataFinal).format('YYYY-MM-DD HH:mm:ss')
          }
        }
        console.log('this' , this.filtro.dataInicial)
        console.log('search ', search.filtro.dataInicial)
        this.dataResumo = await this.loadResumo(search)
        this.isLoadingResumo = false
      },
      filtraTotais(resumo)
      {
        let sucessos = []
        let erros = []

        for(let i in resumo)
        {
            if(resumo[i].name == 'Sucessos')
            {
                for(let r in resumo[i].data)
                {
                    sucessos.push(resumo[i].data[r][1])
                }
            }

            else if(resumo[i].name == 'Erros')
            {
                for(let r in resumo[i].data)
                {
                    erros.push(resumo[i].data[r][1])
                }
            }

        }

        return {
            sucessos: sucessos.reduce((a,b) => a + b, 0),
            erros: erros.reduce((a,b) => a + b, 0)
        }

        //console.log(sucessos, erros)
      },
      convertDataBR (data) {
        return moment(data).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')
      },
      convertDataEUA(data) {
        return moment(data).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss')
      },
    },
    async mounted () {
      this.loadUserLocal()
      this.sendLoadResumo()
    },
    computed: {
      getUserLocal () {
        return this.$store.getters.getUserLocal
      },
      formatDateInicial()
      {
        if (!this.filtro.dataInicial) return null
        const [year, month, day] = this.filtro.dataInicial.split('-')
        return `${day}/${month}/${year}`
      },
      formatDateFinal()
      {
        if (!this.filtro.dataFinal) return null
        const [year, month, day] = this.filtro.dataFinal.split('-')
        return `${day}/${month}/${year}`
      },
    },
    watch: {
      'tipoDeResumo' () {
        if(this.tipoDeResumo == 'atual') {
          this.filtro = {
            dataInicial: moment(new Date()).tz('America/Sao_Paulo').set('date', 1).hour(0).minute(0).second(0).format('YYYY-MM-DDTHH:mm:ss'),
            dataFinal:moment(new Date()).tz('America/Sao_Paulo').set('date', moment(this.hoje).format('D')).hour(23).minute(59).second(59).format('YYYY-MM-DDTHH:mm:ss'),
          }
        } else if (this.tipoDeResumo == 'anterior') {
          let mesAtual = moment(new Date()).format('M') - 2
          let diasMes = moment().month(mesAtual).daysInMonth()
          this.filtro = {
            dataInicial: moment().tz('America/Sao_Paulo').month(mesAtual).set('date', 1).hour(0).minute(0).second(0).format('YYYY-MM-DDTHH:mm:ss'),
            dataFinal: moment().tz('America/Sao_Paulo').month(mesAtual).set('date', diasMes).hour(23).minute(59).second(59).format('YYYY-MM-DDTHH:mm:ss'),
          }
        } else if (this.tipoDeResumo == 'personalizado') {

        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .d-flex
    display flex
    justify-content space-between
    margin-bottom 30px

</style>



// WEBPACK FOOTER //
// src/components/user/mensagens/Informes.vue